import React from "react";

// Style \\
import "../../assets/styles/sections/contactHero.scss";

const ContactHero = () => {
  return (
    <section className="contactHero">
      <div className="contact_bg">
        <div className="containers">
          <div className="contact_items">
            <div className="contact_items_title">
              <p>Home / Contact</p>
              <h2>Contact</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
